import axios from 'axios'
import endpoints from '@/api/endpoints'
import _ from 'lodash'

export default {
  async getSnowTrackerLogs () {
    return axios.get(endpoints.snowTracker).then((response) => {
      return _.orderBy(response.data, 'date')
    })
  },
  async getSnowTrackerLogForDate (dt) {
    return axios.get(endpoints.snowTracker + '?date=' + dt).then((response) => {
      return response.data.length > 0 ? response.data[0] : null
    })
  },
  async createSnowTrackerLog (obj) {
    return axios.post(endpoints.snowTracker, obj).then((response) => {
      return response.data
    })
  },
  async updateSnowTrackerLog (obj) {
    return axios.patch(endpoints.snowTracker + obj.id + '/', obj).then((response) => {
      return response.data
    })
  }
}
